export default {
    // API_BASE_URL: "http://localhost:4000/graphql",
    API_BASE_URL: "https://api-staging.dermaster.asia/graphql",
    LOGIN_WX_URL:
        "https://staff.workinfinityx.com/oauth?client_id=63febb807b3e425b6e49b64a",
    LOGIN_WX_MOBILE_URL:
        "staff.workinfinityx.com://client_id=637d8ec9fe2699db8cad876b",
    CUSTOMER_PAGE_URL: "https://c-staging.dermaster.asia",
};
